import { FC } from "react";
import { Box } from "@chakra-ui/react";
import { landingConfig } from "./config/landing.config";
import { HeroSection } from "./sections/HeroSection";
import { AboutSection } from "./sections/AboutSection";
import { DocumentsSection } from "./sections/DocumentsSection";

const Landing: FC = () => {
  return (
    <Box as="main">
      <HeroSection config={landingConfig.hero} />
      <AboutSection config={landingConfig.about} />
      <DocumentsSection config={landingConfig.documents} />
    </Box>
  );
};

export default Landing;
